import React from 'react'
import { inheritPrimaryColor } from '../colors'
import styled from 'styled-components'

const Tools = styled(props => {
  return (
    <div {...props}>
      <div css='max-width: 1140px; flex-grow: 1; flex-wrap: wrap; display: flex; justify-content: space-evenly;'>
        <Tool
          href='https://signal.mutationalsignatures.com'
          target='_blank'
          imgSrc='/public/signalnew.svg'
          description='Easily explore our mutational signature data and analyse your own samples'
        />
        <Tool
          href='https://github.com/Nik-Zainal-Group/signature.tools.lib'
          target='_blank'
          imgSrc='/public/githubnew.svg'
          description='Access mutational signature analysis via our open-source R package'
        />
      </div>
    </div>
  )
})`
  display: flex;
  justify-content: center;
  padding: 100px 20px 30px;
`

const Tool = ({ description, imgSrc, ...props }) => {
  return (
    <ToolContainer {...props}>
      <img height='300px' src={imgSrc} />
      <Description>
        {description}
      </Description>
    </ToolContainer>
  )
}

const ToolContainer = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 1;
  text-decoration: none;
  transition: color 0.2s, transform 0.2s;
  cursor: pointer;
  color: darkgrey;
  position: relative;
  margin-bottom: 70px;
  &:hover {
    color: rgb(90, 90, 90);
    transform: scale(1.1);
  }
  &:before {
    content: "";
    height: 50px;
    width: 50px;
    transform: scale(0);
    background-color: ${inheritPrimaryColor};
    opacity: 0%;
    transition: transform 0.2s;
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 50%;
    z-index: -1;
  }
  &:hover:before {
    transform: scale(1)
  }
`

const Description = styled.div`
  max-width: 400px;
  font-size: 1.3em;
  text-align: center;
  margin-top: 20px;
  line-height: 1.4em;
`

export default Tools